import React from 'react';
import Weather from './components/Weather';
import './App.css'; // We can use App.css or index.css

function App() {
  return (
    <div className="App">
      <Weather />
    </div>
  );
}

export default App;
